// extracted by mini-css-extract-plugin
export default {"wrapper":"PerizinanLP_wrapper__X6EuV","title":"PerizinanLP_title__m9Ltf","subTitle":"PerizinanLP_subTitle__0vHuY","button":"PerizinanLP_button__mjEjC"};